import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { ButtonContained, ButtonText, FontStyles } from "../../../components";
import { Spacing } from "../../../config";
import { he } from "date-fns/locale";

const Container = styled.div(({ theme, $dark, $row }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: $dark
      ? theme.palette.action.selected
      : theme.palette.background.paper,

    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});

const ContainerSecondary = styled.div(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    backgroundColor: theme.palette.action.selected,
    padding: "16px 20px",
    borderRadius: "10px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",

    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "8px",
    },
  };
});

const Value = styled.p(({ theme, $withError, $color, white }) => {
  const { palette: colors, spacing } = theme;
  return {
    ...FontStyles.medium14,
    paddingBlock: spacing(1.25),
    color: "#272727",
    width: "100%",
    borderBottom: "1px solid #fff",
    margin: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    wordBreak: "break-all",
  };
});

const ButtonContainer = styled.div(({ theme }) => {
  return {
    width: "20%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
    gap: theme.spacing(1),
  };
});
const Submit = styled(ButtonContained)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      backgroundColor: theme.palette.action.selected,
      ...FontStyles.semibold12,
      width: "100%",
    },
  };
});
const Clear = styled(ButtonText)(({ theme }) => {
  return {
    "&&.MuiButton-root": {
      color: theme.palette.action.selected,
      ...FontStyles.semibold12,
      paddingInline: theme.spacing(2.5),
      paddingBlock: theme.spacing(1.9),
    },
  };
});
const OnUse = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    paddingInline: theme.spacing(1.625),
    paddingBlock: theme.spacing(1),
    backgroundColor: "#4D585A",
    color: "white",
    borderRadius: theme.spacing(2),
    margin: 0,
  };
});

const RegitryContainer = styled.div(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
  };
});

const CancelButton = styled(ButtonText)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      marginTop: 0,
      ...FontStyles.medium14,
      color: "#272727",
      paddingInline: spacing(2),
      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});
const MarginBottom = styled.div(({ theme, center }) => {
  const { spacing } = theme;
  return {
    display: "flex",
    width: "100%",

    justifyContent: center ? "center" : "flex-start",
    alignItems: center ? "center" : "flex-start",
    marginBottom: spacing(5),
  };
});
const LabelContainer = styled.div(({ theme }) => {
  const { spacing } = theme;
  return {
    width: "fit-content",
    display: "flex",
    flexDirection: "column",
  };
});
const InputCodeLabel = styled.p(({ theme }) => {
  return {
    ...FontStyles.bold16,
    color: "black",
    fontSize: 12,
  };
});
const SubToken = styled.p(({ theme }) => {
  const { spacing, palette: colors } = theme;
  return {
    color: "white",
    ...FontStyles.semibold14,
    margin: 0,
    paddingTop: spacing(3.5),
    textAlign: "center",
  };
});

const Label = styled.p(({ theme, $witherror }) => {
  const { palette: colors } = theme;
  return {
    ...FontStyles.semibold14,
    textTransform: "capitalize",
    color: $witherror ? colors.error.main : "#0C396D",
    transition: ".2s",
    pointerEvents: "none",
  };
});

const ImageLabel = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b5ca6",
    margin: 0,
    textTransform: "capitalize",
    paddingBottom: "8px",
    "@media (max-width: 1500px)": {
      paddingBottom: "6px",
      fontSize: "10px",
    },
    "@media (max-width: 600px)": {
      paddingBottom: "4px",
      fontSize: "9px",
    },
  };
});

const ImageBox = styled.div(({ theme }) => {
  return {
    width: "100%",
    aspectRatio: "1",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
    display: "flex",
    alignItems: "center",
    height: "31.5vh",
    justifyContent: "center",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    "@media (max-width: 1300px)": {
      height: "50vh",
    },
    "@media (max-width: 960px)": {
      height: "30vh",
      width: "35vw",
      display: "flex",
    },
    "@media (max-width: 600px)": {
      height: "25vh",
      alignItems: "center",
      justifyContent: "center",
      width: "40vw",
    },
  };
});

const RegitryButton = styled(ButtonContained)(({ theme, alternative }) => {
  const { palette: colors, spacing } = theme;
  const bg = alternative ? "#fff" : "#0C396D";
  const txtColor = alternative ? "#24272A" : "#FFFFFF";
  return {
    "&&.MuiButton-root": {
      background: bg,
      color: txtColor,
      borderRadius: 21,
      marginTop: 0,
      transition: "none",
      // keep visuals identical on hover/focus/active to disable hover effect
      "&:hover": {
        background: bg,
        boxShadow: "none",
      },
      "&:focus, &:active": {
        background: bg,
        boxShadow: "none",
      },
      ...FontStyles.medium14,

      "& .MuiButton-label": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  };
});

const ContainerFilter = styled.div(({ theme, noLine }) => {
  return {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    padding: "16px 20px",
    paddingInline: noLine && 0,
    borderRadius: "5px",

    width: "100%",
    marginBottom: theme.spacing(1.5),
    height: "fit-content",
  };
});

const Barra = styled.div(({ theme }) => {
  return {
    width: "100vw",
    backgroundColor: "#E6E6E6",
    marginTop: theme.spacing(4),
    marginLeft: -30,
    height: "5px",
  };
});

const CardsGrid = styled.div(({ theme }) => {
  const { breakpoints } = theme;
  return {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "12px",
    width: "100%",
    [breakpoints.down("lg")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [breakpoints.down("md")]: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    [breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  };
});

const Card = styled.div(({ theme }) => {
  return {
    backgroundColor: "#E9E9E9",
    borderRadius: "10px",
    padding: "16px",
    boxShadow: "0 0 0 1px rgba(0,0,0,0.04)",
    minHeight: "80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "@media (max-width: 1500px)": {
      padding: "12px",
      minHeight: "70px",
    },
    "@media (max-width: 960px)": {
      padding: "10px",
      minHeight: "65px",
    },
    "@media (max-width: 600px)": {
      padding: "8px",
      minHeight: "55px",
    },
  };
});

const CardTitle = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b5ca6",
    margin: 0,
    paddingBottom: "8px",
    textTransform: "uppercase",
    "@media (max-width: 1500px)": {
      paddingBottom: "6px",
      fontSize: "10px",
    },
    "@media (max-width: 600px)": {
      paddingBottom: "4px",
      fontSize: "9px",
    },
    TextTransform: "capitalize",
  };
});

const CardContent = styled.p(({ theme }) => {
  return {
    ...FontStyles.semibold12,
    color: "#2b2b2b",
    margin: 0,
    whiteSpace: "normal",
    wordBreak: "break-word",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    gap: "4px",
    "@media (max-width: 1500px)": {
      fontSize: "11px",
      gap: "2px",
    },
    "@media (max-width: 600px)": {
      fontSize: "10px",
      flexDirection: "column",
      alignItems: "flex-start",
    },
  };
});

const CustomGrid = styled(Grid)`
  width: 100%;
  @media (min-width: 1280px) {
    flex-basis: 12.5% !important;
    max-width: 12.5% !important;
  }
  @media (max-width: 1279px) {
    flex-basis: auto !important;
    max-width: 100% !important;
  }
`;

const Styles = {
  Container,
  Submit,
  Clear,
  ButtonContainer,
  OnUse,
  RegitryContainer,
  RegitryButton,
  ContainerSecondary,
  CancelButton,
  MarginBottom,
  LabelContainer,
  InputCodeLabel,
  SubToken,
  Label,
  ContainerFilter,
  ImageLabel,
  ImageBox,
  Barra,
  Value,
  CardsGrid,
  Card,
  CardTitle,
  CardContent,
  CustomGrid,
};

export default Styles;
